module.exports = __webpack_public_path__ + "img/arrival_notification.0b19456d.png";